import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../environments/environment";

const BACKEND_URL = environment.apiUrl;
@Injectable({
  providedIn: "root",
})

export class ContactFormService {
  constructor(private http: HttpClient) {}

  sendForm(
    name: string,
    phone: string,
    email: string,
    ask_a_question: string,
    meet_with_broker: string,
    contact_agent: string,
    calculate_mortgage: string,
    calculate_titlecost: string,
    schedule_a_meeting: string,
    virtual_tour: string,
    join_stride: string,
    something_else: string,
    state: string,
    message: string,
    source: string
  ) {
    // const URL = "https://www.strideapi.com/api/form/contact";
    const URL = BACKEND_URL+"/form/contact";
    const formDetails = {
      name: name,
      phone: phone,
      email: email,
      ask_a_question: ask_a_question,
      meet_with_broker: meet_with_broker,
      contact_agent: contact_agent,
      calculate_mortgage: calculate_mortgage,
      calculate_titlecost: calculate_titlecost,
      schedule_a_meeting: schedule_a_meeting,
      virtual_tour: virtual_tour,
      join_stride: join_stride,
      something_else: something_else,
      state: state,
      message: message,
      source: source,
    };
    this.http.post(URL, formDetails).subscribe((res) => {
      console.log(res);
    });
  }
}
